var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoInternet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 103,
    height: 103,
    viewBox: "0 0 103 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.0772 37.2726C80.1912 20.0455 58.0982 13.8951 37.7997 18.6515C35.8843 19.101 33.9689 17.911 33.5231 15.9956C33.0736 14.084 34.2598 12.1686 36.1752 11.7191C58.9822 6.37337 83.6933 13.3398 101.31 32.4483C102.643 33.8914 102.552 36.1468 101.106 37.4766C99.6624 38.8102 97.407 38.7195 96.0772 37.2726ZM23.4778 19.917C24.4411 21.6322 23.8329 23.8007 22.1177 24.7641C16.466 27.9375 11.1468 32.1045 6.3791 37.2726C5.04551 38.7195 2.7939 38.8102 1.35075 37.4766C-0.0961785 36.1468 -0.186848 33.8914 1.14674 32.4483C6.4131 26.7361 12.3217 22.1007 18.6308 18.557C20.3459 17.5937 22.5182 18.2019 23.4778 19.917ZM50.6671 35.2363C50.8031 33.2756 52.5032 31.7947 54.4639 31.9307C66.3869 32.7505 78.0454 38.1037 87.0708 47.8922C88.4043 49.3391 88.3137 51.5908 86.8667 52.9206C85.4198 54.2542 83.1682 54.1635 81.8346 52.7166C74.0333 44.2541 64.071 39.7282 53.9728 39.0331C52.0121 38.8971 50.5311 37.1971 50.6671 35.2363ZM39.598 36.8079C40.2704 38.6553 39.3146 40.6991 37.4672 41.3716C31.3395 43.6006 25.5518 47.3709 20.6179 52.7166C19.2881 54.1635 17.0327 54.2542 15.5896 52.9206C14.1426 51.5908 14.052 49.3391 15.3856 47.8922C21.0788 41.7192 27.8223 37.3028 35.0343 34.6772C36.8817 34.0085 38.9255 34.9606 39.598 36.8079ZM53.2625 60.8768C46.7381 60.2534 39.9569 62.6335 34.8605 68.1605C33.5269 69.6074 31.2753 69.6981 29.8284 68.3645C28.3815 67.0347 28.2908 64.7831 29.6244 63.3362C36.2205 56.1809 45.1854 52.9508 53.9388 53.7895C55.8957 53.9746 57.3313 55.7162 57.1462 57.6731C56.9573 59.6301 55.2195 61.0619 53.2625 60.8768Z",
    fill: "#07213C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.4528 75.502C55.3565 70.4056 47.0943 70.4056 41.9941 75.502C36.8978 80.5983 36.8978 88.8643 41.9941 93.9607C47.0943 99.0608 55.3565 99.0608 60.4528 93.9607C65.553 88.8643 65.553 80.5983 60.4528 75.502Z",
    fill: "#07213C"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_16999_89852",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 103,
    height: 103
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H102.516V103H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_16999_89852)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.23801 1.51926C2.62826 0.128998 4.88366 0.128998 6.27391 1.51926L101.204 96.4497C102.595 97.84 102.595 100.095 101.204 101.486C99.8141 102.876 97.5587 102.876 96.1685 101.486L1.23801 6.55516C-0.152252 5.16491 -0.152252 2.90951 1.23801 1.51926Z",
    fill: "#07213C"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoInternet);
export default __webpack_public_path__ + "static/media/no_internet.a8ea1ccfe28454ad276873324003fcef.svg";
export { ForwardRef as ReactComponent };